<template>
  <!-- <div class="inner"> -->
  <router-view></router-view>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'App',
  components: {},
  // 总后台 App.vue
  mounted() {
    // 页面激活时 -> 强制清掉商户端的所有token
    window.addEventListener('focus', () => {
      this.clearMerchantToken()
    })
  },
  methods: {
    clearMerchantToken() {
      // 只要是总后台，激活窗口 -> 干掉商户所有信息
      sessionStorage.removeItem('merchant_admin')
      sessionStorage.removeItem('merchant_shop_id')
      sessionStorage.removeItem('merchant_logo')
      sessionStorage.removeItem('merchant_company_name')
    }
  }

}
</script>
<style>
@import './assets/css/global.css';

body {
  margin: 0;
  padding: 0;

}

.inner {
  overflow: auto;
}

.inner::-webkit-scrollbar {
  width: 0 !important;
}

.border {
  border: 1px solid red;
}

div {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

input {
  border: 0;
  background: none;
  outline: none;
  /*清除input点击之后的黑色边框*/
}

textarea {
  border: 0;
  resize: none;
  background: none;
  outline: none;
  /*清除input点击之后的黑色边框*/
}

.header_form .el-form-item {
  margin-bottom: 0;
}

.el-card {
  margin-bottom: 10px;
}
</style>